import { Link } from "react-router-dom";
import "../styles/Error404.css";

const Error404 = () => {
  return (
    <div className="err-background">
      <div className="ground"></div>
      <div className="err-container">
        <div className="err-left-section">
          <div className="err-inner-content">
            <h1 className="err-heading">404</h1>
            <p className="err-subheading">
              Looks like the page you were looking for is not available.
            </p>
            <p>Click on the lamp to Go Back to <a className="lamp-link" href="/">HOMEPAGE</a>.</p>
          </div>
        </div>
        <div className="err-right-section">
          <svg
            className="svgimg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="51.5 -15.288 385 505.565"
          >
            <defs>
              <radialGradient id="SVGID_1_" cx="119.676" cy="44.22" r="65">
                <stop offset="0%" style={{ stopColor: "#FFFFFF", stopOpacity: 1 }} />
                <stop offset="50%" style={{ stopColor: "#EDEDED", stopOpacity: 0.5 }}>
                  <animate
                    attributeName="stop-opacity"
                    values="0.0; 0.5; 0.0"
                    dur="5000ms"
                    repeatCount="indefinite"
                  />
                </stop>
                <stop offset="100%" style={{ stopColor: "#EDEDED", stopOpacity: 0 }} />
              </radialGradient>
            </defs>

            <g className="bench-legs">
              <path d="M202.778,391.666h11.111v98.611h-11.111V391.666z M370.833,390.277h11.111v100h-11.111V390.277z M183.333,456.944h11.111 v33.333h-11.111V456.944z M393.056,456.944h11.111v33.333h-11.111V456.944z" />
            </g>

            <g className="top-bench">
              <path d="M396.527,397.917c0,1.534-1.243,2.777-2.777,2.777H190.972c-1.534,0-2.778-1.243-2.778-2.777v-8.333 c0-1.535,1.244-2.778,2.778-2.778H393.75c1.534,0,2.777,1.243,2.777,2.778V397.917z" />
            </g>

            <g className="bottom-bench">
              <path d="M417.361,459.027c0,0.769-1.244,1.39-2.778,1.39H170.139c-1.533,0-2.777-0.621-2.777-1.39v-4.86 c0-0.769,1.244-0.694,2.777-0.694h244.444c1.534,0,2.778-0.074,2.778,0.694V459.027z" />
            </g>

            <a href="/">
            <g id="lamp">
              <path
                className="lamp-details"
                d="M125.694,421.997c0,1.257-0.73,3.697-1.633,3.697H113.44c-0.903,0-1.633-2.44-1.633-3.697V84.917 c0-1.257,0.73-2.278,1.633-2.278h10.621c0.903,0,1.633,1.02,1.633,2.278V421.997z"
              />
              <circle className="lamp-light" cx="119.676" cy="44.22" r="40.51" />
              <circle className="lamp-light__glow" fill="url(#SVGID_1_)" cx="119.676" cy="44.22" r="65" />
              <path
                className="lamp-bottom"
                d="M135.417,487.781c0,1.378-1.244,2.496-2.778,2.496H106.25c-1.534,0-2.778-1.118-2.778-2.496v-74.869 c0-1.378,1.244-2.495,2.778-2.495h26.389c1.534,0,2.778,1.117,2.778,2.495V487.781z"
              />
            </g>
            </a>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Error404;
